import FormCheckboxGroupField from "./formCheckboxGroupField"

const FormCheckboxField = props => <FormCheckboxGroupField {...props} options={[{ value: true, name: props.attributeName }]} />

export default FormCheckboxField